<template>
    <div>
        <div v-if="isModalOpen">
            <div class="container-confirm alert alert-danger pull-left">
                <div class="modal-container-v">
                    <div class="modal-body-v">
                        <slot name="body">
                            {{'Your text Here'|trans}}
                        </slot>
                    </div>
                    <div class="modal-footer-v">

                        <button class="modal-default-button-v btn btn-primary spacer-btn" @click="onConfirm">{{'Confirm'|trans}}</button>

                        <button class="modal-default-button-v btn btn-default spacer-btn" @click="onCancel">{{'Cancel'|trans}}</button>

                    </div>
                </div>
            </div>
        </div>

        <span @click="onToggleConfirm">
            <slot name="openBouton">
                <button class="btn btn-primary btn-xs" >{{'Confirm Modal'|trans}}</button>
            </slot>
        </span>
    </div>
</template>

<script>
    export default {
        props:{

        },
        data() {
            return {
                isModalOpen : false
            }
        },
        methods : {
            onCancel(){
                this.$emit('confirmation', false);
                this.onToggleConfirm();
            },
            onConfirm(){
                this.$emit('confirmation', true);
                this.onToggleConfirm();
            },
            onToggleConfirm(){
                this.isModalOpen = !this.isModalOpen;
            }
        }
    }
</script>

<style scoped>

    .container-confirm{
        width: 100%;
        background-color: #eaeaea;
        border:1px solid #d8d8d8;
        padding:10px;
        margin:10px 0px;
    }

    .modal-default-button-v {
        float: right;
    }

    .spacer-btn{
        margin:4px;
    }


</style>